/**
 * Status calculation utilities
 */

export function getDueDateStatus(dueDate: Date): 'early' | 'warning' | 'overdue' | 'due-soon' {
  const today = new Date()
  const due = new Date(dueDate)
  const diffTime = due.getTime() - today.getTime()
  const daysUntilDue = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

  if (daysUntilDue < 0) return 'overdue'
  if (daysUntilDue <= 1) return 'due-soon'
  if (daysUntilDue <= 3) return 'warning'
  return 'early'
}

export function getThemeColorClass(theme: string): string {
  const themeMap = {
    blue: 'theme-blue',
    green: 'theme-green',
    yellow: 'theme-yellow',
    red: 'theme-red',
    purple: 'theme-purple',
    orange: 'theme-orange',
  }
  return themeMap[theme as keyof typeof themeMap] || 'theme-blue'
}
